import type { CaptureResult } from 'posthog-js';

type ExceptionItem = {
  type?: string;
  value?: string;
};

type ExceptionProperties = {
  $exception_list?: ExceptionItem[];
  error_code?: string;
};

type DenyPredicate = (event: CaptureResult, exception: ExceptionItem | null) => boolean;

const getException = (event: CaptureResult): ExceptionItem | null => {
  const list = (event.properties as ExceptionProperties)?.$exception_list;
  return Array.isArray(list) && list.length > 0 ? list[0] : null;
};

const getErrorCode = (event: CaptureResult): string | undefined => (event.properties as ExceptionProperties)?.error_code;

const DENY_PREDICATES: DenyPredicate[] = [
  (_, ex) => ex?.type === 'CancellationError',
  (_, ex) => ex?.value === 'Cancel action',
  (_, ex) => ex?.type === 'AbortError',
  (_, ex) => ex?.value === 'The operation was aborted.',
  (_, ex) => /could\s*not\s*be\s*found/i.test(ex?.value ?? ''),
  (e) => ['s3_not_found', 's3_disabled', 's3_user_disabled'].includes(getErrorCode(e) ?? ''),
];

const shouldFilterError = (event: CaptureResult | null): boolean => {
  if (!event || event.event !== '$exception') {
    return false;
  }

  const exception = getException(event);

  return DENY_PREDICATES.some(predicate => predicate(event, exception));
};

export default shouldFilterError;
